import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { MyContext, ListContext } from "./MyContext";
import COLORS from "./styleConstants";
import { PrimaryText } from "./styleCustom";
import { CheckYes, CheckNo } from "./icons";
// import AuthHelperMethods from "./AuthHelperMethods";
import Select from "react-select";
import { DISPLAY_TIME } from "./UserSettings";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { dateObjToDBTime } from "./momentUtils";
import { ButtonOrange, ModalHeaderBlue } from "./formComponents";
import { Modal } from "react-bootstrap";

import Auth from "./Auth";

const formatInvoiceDate = (value) => {
  if (value == null || value === "") return "Not available";
  const timestamp = Number(value);
  const date = new Date(Number.isFinite(timestamp) ? timestamp * 1000 : value);
  if (!Number.isFinite(date.getTime())) return "Not available";
  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  }).format(date);
};

const formatInvoiceAmount = (value, currency) => {
  if (value == null || value === "") return "Not available";
  const amount = Number(value);
  if (!Number.isFinite(amount)) return "Not available";
  const currencyCode = currency?.toUpperCase();
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: currencyCode,
      currencyDisplay: "code",
    }).format(amount);
  } catch {
    return `${amount.toFixed(2)}${currencyCode ? ` ${currencyCode}` : ""}`;
  }
};

export const FarmUpdatePrefs = () => {
  const { mystate, dispatch } = useContext(MyContext);
  const { listState, dispatch2 } = useContext(ListContext);
  const [activeView, setActiveView] = useState("settings");
  const [currentValue, setCurrentValue] = useState("");
  const [currentField, setCurrentField] = useState("");
  const [finishedEdit, setFinishedEdit] = useState(false);
  const [prefs, setPrefs] = useState();
  const [boolprefs, setBoolPrefs] = useState();
  const [boolprivs, setBoolPrivs] = useState();
  const [calendarPrefs, setCalendarPrefs] = useState();
  const [farmDefaults, setFarmDefaults] = useState();
  const [stripeSubscriptions, setStripeSubscriptions] = useState(null);
  const [selectedPlanTier, setSelectedPlanTier] = useState(null);
  const [selectedPlanPrice, setSelectedPlanPrice] = useState(null);
  const [planUpgradeOptions, setPlanUpgradeOptions] = useState([]);
  const [failedInvoice, setFailedInvoice] = useState(null);
  const [draftInvoices, setDraftInvoices] = useState([]);
  const [upcomingInvoice, setUpcomingInvoice] = useState(null);
  const [lastPaymentDate, setLastPaymentDate] = useState("Not available");
  const [loadingPlan, setLoadingPlan] = useState(false);
  const [planError, setPlanError] = useState("");
  const [schedulingPlanId, setSchedulingPlanId] = useState("");
  const [planChangeMessage, setPlanChangeMessage] = useState("");
  const [scheduledPlan, setScheduledPlan] = useState(null);
  const [showPlanChangeModal, setShowPlanChangeModal] = useState(false);
  const [planDetailsRefreshed, setPlanDetailsRefreshed] = useState(true);
  let cv = "";
  let cf = ";";

  useEffect(
    () => {
      const fetchData = async () => {
        try {
          dispatch({ type: "FETCH_INIT" });

          const result = await Auth.api("farms/getFarmPrefs", "get");

          setFarmDefaults(result.data.farmDefaults);

          dispatch({ type: "FETCH_SUCCESS" });
        } catch (error) {
          dispatch({ type: "FETCH_ERROR" });

          console.log("error");
        }
      };
      fetchData();
    },
    //eslint-disable-next-line
    [],
  );

  useEffect(
    () => {
      const fetchData = async () => {
        try {
          dispatch({ type: "FETCH_INIT" });

          let params = { value: currentValue, field: currentField };
          //   let params = { value: currentValue, field: cf };

          const result = await Auth.api(
            "farms/updateFarmPreferencesClient",
            "post",
            params,
          );

          dispatch({
            type: "UPDATE_FARM_DEFAULTS",
            data: result.data.farmDefaults,
          });
          dispatch({ type: "FETCH_SUCCESS" });
          setFinishedEdit(false);
          setCurrentValue(false);
          setCurrentField(false);
          setFarmDefaults(result.data.farmDefaults);
        } catch (error) {
          console.log(error);
          dispatch({ type: "FETCH_ERROR" });
          setFinishedEdit(false);

          console.log("error");
        }
      };

      if (finishedEdit) fetchData();
    },
    //eslint-disable-next-line
    [finishedEdit],
  );

  const clickPortal = async () => {
    const result = await Auth.api("payments/stripePortal", "post", {});
    if (result) window.location.href = result.data.portal;
  };

  const loadCurrentPlan = async () => {
    if (loadingPlan) return false;
    setLoadingPlan(true);
    setPlanError("");
    setStripeSubscriptions(null);
    setSelectedPlanTier(null);
    setSelectedPlanPrice(null);
    setPlanUpgradeOptions([]);
    setFailedInvoice(null);
    setDraftInvoices([]);
    setUpcomingInvoice(null);
    setLastPaymentDate("Not available");
    try {
      const result = await Auth.api(
        "farm_billing/stripe_account_info",
        "get",
        {},
      );
      const subscriptions = result?.data?.subscriptions;
      if (!Array.isArray(subscriptions)) {
        throw new Error(
          "Unable to retrieve subscription details for this farm.",
        );
      }
      const paidAt = Number(result.data.most_recent_paid_invoice_paid_at);
      const paymentDate = new Date(paidAt * 1000);
      if (paidAt > 0 && Number.isFinite(paymentDate.getTime())) {
        setLastPaymentDate(
          new Intl.DateTimeFormat(undefined, {
            year: "numeric",
            month: "short",
            day: "numeric",
          }).format(paymentDate),
        );
      }
      setFailedInvoice(
        result.data.most_recent_failed_invoice ??
          result.data.most_reacent_failed_invoice ??
          null,
      );
      setStripeSubscriptions(subscriptions);
      setSelectedPlanTier(result.data.selected_plan?.tier ?? null);
      setSelectedPlanPrice(
        result.data.selected_plan?.price != null
          ? formatInvoiceAmount(
              result.data.selected_plan.price,
              result.data.selected_plan.currency || farmDefaults.currency_code,
            )
          : null,
      );
      setPlanUpgradeOptions(
        Array.isArray(result.data.premium_plans)
          ? result.data.premium_plans.map((plan) => ({
              name: plan.plan_desc,
              stripePlanId: plan.plan_code,
              price: formatInvoiceAmount(plan.price, "USD"),
            }))
          : [],
      );
      setDraftInvoices(
        Array.isArray(result.data.draft_invoices)
          ? result.data.draft_invoices
          : [],
      );
      setUpcomingInvoice(
        subscriptions.find((subscription) => subscription.upcoming_invoice)
          ?.upcoming_invoice ?? null,
      );
      return true;
    } catch (error) {
      setPlanError(
        error.response?.data?.message ||
          error.message ||
          "Unable to retrieve your current plan. Please try again.",
      );
      return false;
    } finally {
      setLoadingPlan(false);
    }
  };

  useEffect(() => {
    if (activeView === "billing") loadCurrentPlan();
  }, [activeView]);

  useEffect(() => {
    if (activeView !== "billing" || loadingPlan || !farmDefaults) return;
    const conditions = {
      subscriptionsLoaded: stripeSubscriptions !== null,
      countryIsUS: farmDefaults.country_code === "US",
      tierExists: Boolean(selectedPlanTier),
      upgradeOptionsAvailable: planUpgradeOptions.length > 0,
      tierIsNotPremium: selectedPlanTier !== "PREMIUM",
    };
    const failedConditions = Object.keys(conditions).filter(
      (condition) => !conditions[condition],
    );
    console.warn("[Billing] Upgrade section visibility", {
      countryCode: farmDefaults.country_code,
      selectedPlanTier,
      upgradeOptionCount: planUpgradeOptions.length,
      conditions,
      failedConditions,
      visible: failedConditions.length === 0,
    });
  }, [
    activeView,
    loadingPlan,
    farmDefaults,
    stripeSubscriptions,
    selectedPlanTier,
    planUpgradeOptions,
  ]);

  const schedulePlanChange = async (stripePlanId) => {
    if (
      !stripePlanId ||
      schedulingPlanId ||
      scheduledPlan?.stripePlanId === stripePlanId
    )
      return;
    setSchedulingPlanId(stripePlanId);
    setPlanChangeMessage("");
    setPlanError("");
    try {
      const result = await Auth.api(
        "farm_billing/schedule_plan_change",
        "post",
        { price_id: stripePlanId },
      );
      if (!result?.data) {
        throw new Error(
          "Unable to confirm the plan change. Please check billing before trying again.",
        );
      }
      setScheduledPlan(
        planUpgradeOptions.find(
          (option) => option.stripePlanId === stripePlanId,
        ),
      );
      setPlanChangeMessage(
        result?.data?.message || "Plan change scheduled successfully.",
      );
      setPlanDetailsRefreshed(await loadCurrentPlan());
      setShowPlanChangeModal(true);
    } catch (error) {
      setPlanError(
        error.response?.data?.message ||
          error.message ||
          "Unable to schedule the plan change. Please try again.",
      );
    } finally {
      setSchedulingPlanId("");
    }
  };

  const clickYesNo = (value, field) => {
    console.log(value);
    console.log(field);
    setCurrentField(field);
    setCurrentValue(value);
    console.log("FINISHED");
    setFinishedEdit(true);
  };

  const YesNo = (props) => {
    return (
      <div
        style={{
          display: "flex",
          direction: "row",
          alignItems: "center",
          marginTop: 10,
        }}
      >
        {props.value == 0 && (
          <>
            <div onClick={() => clickYesNo("1", props.field)}>
              <CheckNo fontSize={40} margin={20} yn={"Yes"} />{" "}
            </div>

            <div onClick={() => clickYesNo("0", props.field)}>
              <CheckYes fontSize={40} margin={20} yn={"No"} />
            </div>
          </>
        )}
        {props.value == 1 && (
          <>
            <div onClick={() => clickYesNo("1", props.field)}>
              <CheckYes fontSize={40} margin={20} yn={"Yes"} />{" "}
            </div>

            <div onClick={() => clickYesNo("0", props.field)}>
              <CheckNo fontSize={40} margin={20} yn={"No"} />{" "}
            </div>
          </>
        )}
      </div>
    );
  };
  const handleBlur = (e, field) => {
    console.log(e.target.value);
    console.log(field);
    setCurrentField(field);
    setCurrentValue(e.target.value);
    setFarmDefaults({ ...farmDefaults, [field]: e.target.value });
    setFinishedEdit(true);
  };
  const handleChangeInput = (e, field) => {
    console.log(e);
    console.log(field);
    console.log(e.target.value);
    // cv = e.target.value;
    // cf = field;
    // setFarmDefaults({ ...farmDefaults, [field]: e.target.value });

    // setCurrentField(field);
    // setCurrentValue(e.target.value);
  };

  const description = {
    clients_can_book_lessons:
      "Clients can add themselves to existing lessons. They will only be able to add themselves to lessons that have a section with a maximum enrollment filled in, and where there is an availability based on that number",
    restrict_client_sections:
      "When clients can book lessons, restricting client sections will restrict them to seeing only those events of the sections that they have been assigned to. When this is 'Yes', go to client's page under 'Student Details' and assign sections for client. If no sections are assigned, they will see all sections. **Only valid when 'Clients can book lessons' is checked.",
    clients_can_book_makeups:
      "Clients can book their own makeups when they have been granted.  To book they will click on the orange 'Book Makeup Lesson' button on their page. They do not need the 'clients can book lessons' privilege to do this ",
    clients_can_cancel:
      "Clients can cancel their own lessons from their Schedule page. Your setup will determine if they have given enough notice and if so, will assign them the appropriate makeup action chosen in your Equine Office setup meeting. ",
    clients_can_view_horses:
      "If clients have horses assigned to their profile, they will be able to see the pages of those horses.",
    clients_can_view_calendar:
      "Clients will be able to view your calendar without restrictions. They will not be able to see any client or horse names unless specified by the settings below.",
    clients_can_view_other_students_on_calendar:
      "Clients  can see the names of other students enrolled when booking a lesson.",
    clients_can_view_other_horses_on_calendar:
      "Clients with the view calendar permission can see the names of  horses on the calendar.",
    clients_can_add_lesson:
      "Clients will be able to create a lesson for themselves. They will not be able to assign any other clients to it. They need to have the 'Clients can view calendar' privilege as they will create the lesson by clicking on the calendar.",
    restrict_client_add_sections:
      "When clients can create their own lessons, you can restrict them to the lesson sections you choose. When this is 'Yes' you can assign the sections on the client's page under Student Details.",
    farm_name: "The name that appears as 'from' on your emails",
    email:
      "The from and reply-to address of your emails.  Also the email address that recieves copies of emails sent to clients.",
    show_general_lesson_notes_on_daysheet:
      "The area where you add the general lesson notes when adding or editing a lesson on the calendar can be shown on the day sheet as well.",
    large_font_on_daysheet:
      "Need your glasses to read the Daysheet?  This is for you.",
    booking_hours_buffer:
      "When clients book lesson, they cannot book within this number of hours before the start of the lesson.",
    restrict_future_booking_days:
      "The number of days in advance a client is allowed to book. Leave blank if you to not want to restrict.",
    cancel_notice_hours:
      "The number of hours notice that the client needs to give in order not to have to pay for that lesson.",
    makeup_expiry_days:
      "The number of days after the cancelled lesson that the makeup lesson expires.",
    makeup_start_before_days:
      "The number of days before the cancelled lesson that the student can schedule a makeup.",
    send_reminders:
      "Reminders will be sent to client by email one day before the scheduled event. Note that they will be sent for all events, and to all clients that are included in the event (if they have an email address).",
    send_notifications:
      "These are the propmts asking you if you would like to notify clients and staff when a change is made to an event.  You would normally want this on as you will still have the option not to check Yes to the prompts. It is useful to have off when you are starting with the system and aren't ready to go live with clients yet.",
    send_cancellation_notifications:
      "Apart from the general notifications, you can prevent the system from sending out notifiations when a student is cancelled",
    show_general_lesson_notes_on_client_page:
      "The general lesson notes (for the lesson as a whole - not the student lesson notes) will be shown on the client's schedule and history on their page.",
    show_paid_not_paid:
      "In the calendar you can see paid or not paid status beside the student name. You can turn this off if you are not recording payment in the system. Without it, you can tell if a lesson has been paid if there link to the package.",
    give_barn_makeups_to_non_paid:
      "If set to yes, when cancelling a lesson and using the cancel action Cancel with Makeup (barn cancel), this allow students that haven't yet paid to be given a makeup.  This is helpful when you are not recording payments or packages in the Equine Office System and thus all your students will have a non paid status.",
    package_start_before_days:
      "When a package is purchased, the package start date defaults to the purchase date.  Use this setting if you would like the package start date to default to a specific number of days before the purchase date.",
    min_time: "The starting time for the day and week calendars",
    max_time: "The starting time for the day and week calendars",
    monday_start:
      "Have the calender week start on the Monday instead of Sunday",
    default_calendar_view: "The view when you first go to the calendar page",
    default_day_view:
      "When clicking on the Day view, choose which type of calendar you wish to see",
    show_lesson_by_client_name:
      "When chosen, this will default to showing the event by the client name instead of the title.  You can change it back on the calendar.",
    timepicker_interval:
      "When entering a time for your event, this is the increment in minutes for the dropdown.",
    calendar_interval:
      "This will be the selectable time increments in minutes on the Day and Week calenday views.  The default is 15 minutes.",
    calendar_timeslot:
      "This is how the time on the first column of the calendar increments on the Day and Week view of the calendar. It is determined in conjuction with the calendar interval. For example if the calendar interval is 15 and the timeslot is 2, the times on the left will be in 15 mulitplied by 2 increments thus 7:00, 7:30, 8:00 etc.  The default is 2.",
    address: "The steet address as you would like it to appear on invoices",
    address2:
      "The city, state/province, zip/postal code as you would like it to appear on invoices",
    invoice_notes1:
      "Custom field for notes you would like to appear on invoice pdf",
    invoice_notes2:
      "Second custom field for notes you would like to appear on invoice pdf",
    invoice_email_notes1:
      "Custom notes you would like to appear in the email body when sending an invoice",
    invoice_email_notes2:
      "Second custom notes you would like to appear in the email body when sending an invoice",
    receipt_email_notes1:
      "Custom notes you would like to appear in the email body when sending a receipt",
    receipt_email_notes2:
      "Second custom notes you would like to appear in the email body when sending a receipt.",
    clients_can_rebook_makeups:
      "Allow a client to rebook a makeup lesson that they have cancelled.",
    limit_makeups_per_month:
      "Enter the maximum number of student self cancellation makeups allowed per month. Leave blank if you do not want a restriction.",
  };

  const descriptionCalendarPrefs = {
    min_time: "The starting time for the day and week calendars",
    max_time: "The end time for the day and week calendars",
    default_calendar_view: "The view when you first go to the calendar",
    default_day_view:
      "When clicking on the Day view, choose which type of calendar you wish to see",
  };

  const viewOptions = ["day", "week", "month", "agenda"];
  const viewOptions2 = [
    { label: "day", value: "day" },
    { label: "week", value: "week" },
    { label: "month", value: "month" },
    { label: "agenda", value: "agenda" },
  ];

  const dayOptions = [
    { label: "staff", value: "instructor" },
    { label: "location", value: "location" },
    { label: "section", value: "section" },
    { label: "none", value: "default" },
  ];

  /*if (!prefs) return null;
  if (!boolprefs) return null;
  if (!boolprivs) return null;
  if (!calendarPrefs) return null;*/
  if (!farmDefaults) return null;

  const Status = () => {
    return (
      <div style={{ marginTop: 5 }}>
        {"Status: "}{" "}
        {mystate.farmDefaults.eqo_subscription_id ? "Live" : "Free Trial"}
      </div>
    );
  };

  const SubscriptionLink = () => {
    if (
      !mystate.farmDefaults.eqo_subscription_id &&
      mystate.farmDefaults.eqo_stripe_customer_id
    ) {
      return (
        <Link to={"/admin/setup/preferences/paymentSubscriptions"}>
          {" "}
          Click here to Subscribe
        </Link>
      );
    }
    return null;
  };

  const Success = () => {
    return <div>success!</div>;
  };

  const BoolObject = ({ keyarray }) => {
    const filtered = Object.keys(farmDefaults)
      .filter((key) => keyarray.includes(key))
      .reduce((obj, key) => {
        obj[key] = farmDefaults[key];
        return obj;
      }, {});
    return Object.keys(filtered).map((key, i) => (
      <div
        key={key}
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          flex: "1 1 100%",
        }}
      >
        <div
          style={{ display: "flex", flexDirection: "column", marginBottom: 20 }}
        >
          <div
            style={{
              fontSize: 16,
              width: 300,
              background: COLORS.blue,
              color: "white",
              padding: 5,
            }}
          >
            {key.replaceAll("_", " ")}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              flex: "1 1 100%",
            }}
          >
            <div style={{ width: 300 }}>
              <YesNo value={farmDefaults[key]} field={key} />
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            padding: 5,
            marginLeft: 20,
          }}
        >
          {description[key]}
        </div>
      </div>
    ));
  };

  const InputObject = ({ keyarray, header }) => {
    const filtered = Object.keys(farmDefaults)
      .filter((key) => keyarray.includes(key))
      .reduce((obj, key) => {
        obj[key] = farmDefaults[key];
        return obj;
      }, {});

    return (
      <>
        {Object.keys(filtered).map((key, i) => (
          <div
            key={key}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              flex: "1 1 100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  fontSize: 16,
                  width: 300,
                  background: COLORS.blue,
                  color: "white",
                  padding: 5,
                }}
              >
                {key.replaceAll("_", " ")}
              </div>
              <div style={{ width: 300, display: "flex", flex: "0 0 auto" }}>
                <input
                  key={key}
                  style={{
                    width: 300,
                    padding: 10,
                    fontSize: 14,
                    borderTop: "none",
                  }}
                  onBlur={(e) => handleBlur(e, key)}
                  defaultValue={farmDefaults[key]}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                padding: 5,
                marginLeft: 20,
              }}
            >
              {description[key]}
            </div>
          </div>
        ))}
      </>
    );
  };

  const TextboxObject = ({ keyarray, header }) => {
    const filtered = Object.keys(farmDefaults)
      .filter((key) => keyarray.includes(key))
      .reduce((obj, key) => {
        obj[key] = farmDefaults[key];
        return obj;
      }, {});

    return (
      <>
        {Object.keys(filtered).map((key, i) => (
          <div
            key={key}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              flex: "1 1 100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  fontSize: 16,
                  width: 600,
                  background: COLORS.blue,
                  color: "white",
                  padding: 5,
                }}
              >
                {key.replaceAll("_", " ")}
              </div>
              <div style={{ width: 600, display: "flex", flex: "0 0 auto" }}>
                <textarea
                  key={key}
                  style={{
                    width: 600,
                    padding: 10,
                    fontSize: 14,
                    borderTop: "none",
                  }}
                  onChangex={(e) => handleChangeInput(e, key)}
                  onFocuss={(e) => (e.target.value = "")}
                  onBlur={(e) => handleBlur(e, key)}
                  defaultValue={farmDefaults[key]}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                padding: 5,
                marginLeft: 20,
              }}
            >
              {description[key]}
            </div>
          </div>
        ))}
      </>
    );
  };
  const sectionStyle = {
    border: "solid 2pt darkgrey",
    padding: 10,
    marginBottom: 10,
  };
  const sectionTitleStyle = { color: "darkgrey" };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        flex: "1 1 100%",
        flexWrap: "wrap",
      }}
    >
      <div
        role="tablist"
        aria-label="Farm preferences views"
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 4,
          borderBottom: `1px solid ${COLORS.lightblue}`,
          padding: "0 12px",
          marginBottom: 16,
        }}
      >
        {[
          { id: "settings", label: "Settings" },
          { id: "billing", label: "Billing" },
        ].map((view) => (
          <button
            key={view.id}
            type="button"
            role="tab"
            id={`farm-preferences-tab-${view.id}`}
            aria-selected={activeView === view.id}
            aria-controls={`farm-preferences-panel-${view.id}`}
            onClick={() => setActiveView(view.id)}
            style={{
              padding: "10px 12px",
              border: "none",
              borderBottom:
                activeView === view.id
                  ? `3px solid ${COLORS.blue}`
                  : "3px solid transparent",
              marginBottom: -1,
              background: "transparent",
              color: activeView === view.id ? COLORS.blue : COLORS.textgrey,
              font: "inherit",
              fontSize: 18,
              fontWeight: activeView === view.id ? 700 : 500,
              cursor: "pointer",
            }}
          >
            {view.label}
          </button>
        ))}
      </div>
      <div
        id="farm-preferences-panel-billing"
        role="tabpanel"
        aria-labelledby="farm-preferences-tab-billing"
        hidden={activeView !== "billing"}
        style={{ width: "100%", minWidth: 0 }}
      >
        <Modal
          show={showPlanChangeModal}
          onHide={() => setShowPlanChangeModal(false)}
          centered
          size="md"
        >
          <ModalHeaderBlue closeButton>
            <Modal.Title>Plan change scheduled</Modal.Title>
          </ModalHeaderBlue>
          <Modal.Body>
            <p style={{ fontWeight: 600, marginBottom: 8 }}>
              {scheduledPlan?.name} - {scheduledPlan?.price} / month
            </p>
            <p>
              Your request succeeded.{" "}
              {planDetailsRefreshed
                ? "Billing details and the upcoming invoice have been reloaded below."
                : "Billing details could not be reloaded; use Retry to try again."}{" "}
              Your current plan remains active until the scheduled change takes
              effect.
            </p>
            {planChangeMessage && <p>{planChangeMessage}</p>}
          </Modal.Body>
        </Modal>
        <div style={{ marginBottom: 16 }}>
          <ButtonOrange
            type="button"
            onClick={clickPortal}
            label="Manage Payment Method"
          />
        </div>
        <div style={{ marginBottom: 10 }}>
          <div
            style={{
              fontSize: 16,
              width: 300,
              background: COLORS.blue,
              color: "white",
              padding: 5,
            }}
          >
            {"Equine Office Subscription"}
          </div>

          <Status />
          <SubscriptionLink />
        </div>
        <div id="plan-status" style={{ marginBottom: 10 }}>
          {scheduledPlan && (
            <div
              role="status"
              style={{
                borderLeft: `3px solid ${COLORS.blue}`,
                padding: "8px 14px",
                margin: "16px 0 24px",
                overflowWrap: "anywhere",
              }}
            >
              <div style={{ fontSize: 18, fontWeight: 700 }}>
                Plan change scheduled
              </div>
              <div style={{ marginTop: 6, fontWeight: 600 }}>
                {scheduledPlan.name} - {scheduledPlan.price} / month
              </div>
              <div style={{ marginTop: 6 }}>{planChangeMessage}</div>
              <div style={{ marginTop: 6 }}>
                The current plan remains active until the scheduled change takes
                effect.
              </div>
              <button
                type="button"
                disabled={loadingPlan}
                onClick={loadCurrentPlan}
                style={{
                  marginTop: 10,
                  padding: "7px 10px",
                  border: `1px solid ${COLORS.blue}`,
                  borderRadius: 4,
                  background: "white",
                  color: COLORS.blue,
                  font: "inherit",
                  cursor: loadingPlan ? "wait" : "pointer",
                }}
              >
                {loadingPlan
                  ? "Refreshing billing details..."
                  : "Refresh billing details"}
              </button>
            </div>
          )}
          {loadingPlan && <div role="status">Loading plan...</div>}
          {stripeSubscriptions !== null && (
            <div
              aria-live="polite"
              style={{ marginTop: 8, overflowWrap: "anywhere" }}
            >
              {stripeSubscriptions.length === 0 && (
                <div>No subscriptions found.</div>
              )}
              {stripeSubscriptions.map((subscription) => (
                <dl key={subscription.id} style={{ margin: "12px 0" }}>
                  <dt>Current Plan</dt>
                  <dd>
                    {subscription.items?.map((item, index) => (
                      <div key={index}>{item.plan_name || "Unnamed plan"}</div>
                    )) || "Not available"}
                  </dd>
                  <dt>Status</dt>
                  <dd>{subscription.status || "Not available"}</dd>
                </dl>
              ))}
              <dl style={{ margin: "12px 0" }}>
                {selectedPlanPrice !== null && (
                  <>
                    <dt>Plan Price</dt>
                    <dd>{selectedPlanPrice}</dd>
                  </>
                )}
                <dt>Last Payment Date</dt>
                <dd>{lastPaymentDate}</dd>
              </dl>
              {failedInvoice && (
                <dl style={{ margin: "12px 0" }}>
                  <dt>Last Failed Payment</dt>
                  <dd>
                    <div>{failedInvoice.id}</div>
                    <div>
                      Invoice Date:{" "}
                      {formatInvoiceDate(failedInvoice.invoice_date)}
                    </div>
                    <div>Status: {failedInvoice.status || "Not available"}</div>
                    <div>
                      Amount due: {failedInvoice.amount_due ?? "Not available"}{" "}
                      {failedInvoice.currency?.toUpperCase()}
                    </div>
                    <div>
                      Amount paid:{" "}
                      {failedInvoice.amount_paid ?? "Not available"}{" "}
                      {failedInvoice.currency?.toUpperCase()}
                    </div>
                    {failedInvoice.hosted_invoice_url?.startsWith(
                      "https://",
                    ) && (
                      <a
                        href={failedInvoice.hosted_invoice_url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {failedInvoice.status === "open"
                          ? "Pay Invoice"
                          : "View Invoice"}
                      </a>
                    )}
                  </dd>
                </dl>
              )}
              {draftInvoices.length > 0 && (
                <section
                  aria-label="Other Unpaid Invoices"
                  style={{
                    margin: "20px 0",
                    paddingTop: 16,
                    borderTop: "1px solid #ddd",
                  }}
                >
                  <h3 style={{ fontSize: 16, marginBottom: 8 }}>
                    Other Unpaid Invoices
                  </h3>
                  <p>Please contact Equine Office regarding payment.</p>
                  <ul style={{ paddingLeft: 20 }}>
                    {draftInvoices.map((invoice, index) => (
                      <li key={invoice.id || index} style={{ marginBottom: 8 }}>
                        {formatInvoiceDate(invoice.invoice_date)}
                        {" - Amount due: "}
                        {formatInvoiceAmount(
                          invoice.amount_due,
                          invoice.currency,
                        )}
                      </li>
                    ))}
                  </ul>
                </section>
              )}
              <section
                aria-label="Upcoming Invoice"
                style={{
                  margin: "20px 0",
                  paddingTop: 16,
                  borderTop: "1px solid #ddd",
                }}
              >
                <h3 style={{ fontSize: 16, marginBottom: 12 }}>
                  Upcoming Invoice{upcomingInvoice?.preview ? " (Preview)" : ""}
                </h3>
                {upcomingInvoice ? (
                  <>
                    <dl>
                      <dt>Subtotal</dt>
                      <dd>
                        {formatInvoiceAmount(
                          upcomingInvoice.subtotal,
                          upcomingInvoice.currency,
                        )}
                      </dd>
                      <dt>Tax</dt>
                      <dd>
                        {formatInvoiceAmount(
                          upcomingInvoice.tax,
                          upcomingInvoice.currency,
                        )}
                      </dd>
                      <dt>Total</dt>
                      <dd>
                        {formatInvoiceAmount(
                          upcomingInvoice.total,
                          upcomingInvoice.currency,
                        )}
                      </dd>
                      <dt>Amount Due</dt>
                      <dd>
                        {formatInvoiceAmount(
                          upcomingInvoice.amount_due,
                          upcomingInvoice.currency,
                        )}
                      </dd>
                      <dt>Collection Method</dt>
                      <dd>
                        {upcomingInvoice.collection_method ===
                        "charge_automatically"
                          ? "Automatic charge"
                          : upcomingInvoice.collection_method === "send_invoice"
                            ? "Send invoice"
                            : upcomingInvoice.collection_method ||
                              "Not available"}
                      </dd>
                      <dt>Next Payment Attempt</dt>
                      <dd>
                        {formatInvoiceDate(
                          upcomingInvoice.next_payment_attempt,
                        )}
                      </dd>
                      <dt>Period End</dt>
                      <dd>{formatInvoiceDate(upcomingInvoice.period_end)}</dd>
                      {upcomingInvoice.due_date != null && (
                        <>
                          <dt>Due Date</dt>
                          <dd>{formatInvoiceDate(upcomingInvoice.due_date)}</dd>
                        </>
                      )}
                    </dl>
                    {Array.isArray(upcomingInvoice.line_items) &&
                      upcomingInvoice.line_items.length > 0 && (
                        <>
                          <div style={{ fontWeight: 600 }}>Line Items</div>
                          <ul style={{ paddingLeft: 20 }}>
                            {upcomingInvoice.line_items.map((item, index) => (
                              <li key={index} style={{ marginTop: 8 }}>
                                <div>{item.description || "Invoice item"}</div>
                                <div>
                                  Quantity: {item.quantity ?? "Not available"}
                                  {" | "}
                                  {formatInvoiceAmount(
                                    item.amount,
                                    item.currency || upcomingInvoice.currency,
                                  )}
                                </div>
                              </li>
                            ))}
                          </ul>
                        </>
                      )}
                  </>
                ) : (
                  <div>No upcoming invoice available.</div>
                )}
              </section>
            </div>
          )}
          {planError && (
            <div role="alert" style={{ marginTop: 8, color: "#b42318" }}>
              {planError}
              {stripeSubscriptions === null && !loadingPlan && (
                <button type="button" onClick={loadCurrentPlan}>
                  Retry
                </button>
              )}
            </div>
          )}
          {stripeSubscriptions !== null &&
            farmDefaults.country_code === "US" &&
            Boolean(selectedPlanTier) &&
            planUpgradeOptions.length > 0 &&
            selectedPlanTier !== "PREMIUM" && (
              <div
                style={{
                  marginTop: 20,
                  paddingTop: 16,
                  borderTop: "1px solid #ddd",
                }}
              >
                <div style={{ marginBottom: 8, fontWeight: 600 }}>
                  Choose an upgrade plan
                </div>
                <div style={{ display: "grid", gap: 10, maxWidth: 520 }}>
                  {planUpgradeOptions.map((option) => (
                    <button
                      key={option.stripePlanId}
                      type="button"
                      aria-label={`Upgrade to ${option.name} for ${option.price} per month`}
                      disabled={
                        !option.stripePlanId ||
                        Boolean(schedulingPlanId) ||
                        scheduledPlan?.stripePlanId === option.stripePlanId
                      }
                      onClick={() => schedulePlanChange(option.stripePlanId)}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 16,
                        width: "100%",
                        padding: "14px 16px",
                        border: "1px solid #cbd5d9",
                        borderLeft: `4px solid ${COLORS.blue}`,
                        borderRadius: 6,
                        background: "white",
                        color: "#263238",
                        textAlign: "left",
                        cursor: schedulingPlanId
                          ? "wait"
                          : scheduledPlan?.stripePlanId === option.stripePlanId
                            ? "default"
                            : "pointer",
                        opacity: schedulingPlanId ? 0.65 : 1,
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 4,
                        }}
                      >
                        <span style={{ fontSize: 15, fontWeight: 600 }}>
                          {option.name}
                        </span>
                        <span style={{ fontSize: 13, color: "#526268" }}>
                          {schedulingPlanId === option.stripePlanId
                            ? "Scheduling plan change..."
                            : scheduledPlan?.stripePlanId ===
                                option.stripePlanId
                              ? "Scheduled"
                              : "Select this plan"}
                        </span>
                      </span>
                      <span
                        style={{
                          whiteSpace: "nowrap",
                          fontSize: 18,
                          fontWeight: 700,
                        }}
                      >
                        {option.price}
                        <span style={{ fontSize: 13, fontWeight: 400 }}>
                          / month
                        </span>
                      </span>
                    </button>
                  ))}
                </div>
              </div>
            )}
        </div>
      </div>
      <div
        id="farm-preferences-panel-settings"
        role="tabpanel"
        aria-labelledby="farm-preferences-tab-settings"
        hidden={activeView !== "settings"}
        style={{ width: "100%", minWidth: 0 }}
      >
        <div style={sectionStyle}>
          <h3 style={sectionTitleStyle}>{"Business Information"}</h3>
          <InputObject
            keyarray={["farm_name", "email", "address", "address2"]}
          />
        </div>

        <div style={sectionStyle}>
          <h3 style={sectionTitleStyle}>{"Daysheet Preferences"}</h3>
          <BoolObject
            keyarray={[
              "show_general_lesson_notes_on_daysheet",
              "large_font_on_daysheet",
            ]}
          />
        </div>

        <div style={sectionStyle}>
          <h3 style={sectionTitleStyle}>{"Booking Preferences"}</h3>
          <InputObject
            keyarray={[
              "booking_hours_buffer",
              "makeup_expiry_days",
              "makeup_start_before_days",
              "cancel_notice_hours",
              "restrict_future_booking_days",
              "limit_makeups_per_month",
            ]}
          />
          <BoolObject keyarray={[""]} />
        </div>

        <div style={sectionStyle}>
          <h3 style={sectionTitleStyle}>{"Package Preferences"}</h3>
          <InputObject keyarray={["package_start_before_days"]} />
          <BoolObject keyarray={[""]} />
        </div>
        <div style={sectionStyle}>
          <h3 style={sectionTitleStyle}>{"Clients"}</h3>
          <BoolObject
            keyarray={[
              "restrict_client_sections",
              "clients_can_book_lessons",
              "clients_can_book_makeups",
              "clients_can_cancel",
              "clients_can_view_horses",
              "clients_can_view_calendar",
              "clients_can_view_other_students_on_calendar",
              "clients_can_view_other_horses_on_calendar",
              "clients_can_add_lesson",
            ]}
          />
        </div>
        <div style={sectionStyle}>
          <h3 style={sectionTitleStyle}>{"Misc"}</h3>
          <BoolObject
            keyarray={[
              "send_reminders",
              "send_notifications",
              "send_cancellation_notifications",
              "show_general_lesson_notes_on_client_page",
              "show_paid_not_paid",
              "give_barn_makeups_to_non_paid",
              "clients_can_rebook_makeups",
            ]}
          />
        </div>

        <div style={sectionStyle}>
          <h3 style={sectionTitleStyle}>{"Calendar Preferences"}</h3>

          {Object.keys(descriptionCalendarPrefs).map((key, i) => (
            <div
              key={key}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                flex: "1 1 100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: 20,
                }}
              >
                <div
                  style={{
                    fontSize: 16,
                    width: 300,
                    background: COLORS.blue,
                    color: "white",
                    padding: 5,
                  }}
                >
                  {key.replaceAll("_", " ")}
                </div>

                <div style={{ width: 300, display: "flex", flex: "0 0 auto" }}>
                  {key == "min_time" && (
                    <DatePicker
                      showTimeSelect
                      dateFormat={DISPLAY_TIME}
                      onChange={(date) =>
                        clickYesNo(dateObjToDBTime(date), "min_time")
                      }
                      showTimeSelectOnly
                      name="default_start_time"
                      selected={mystate.farmDefaults.min_time}
                    />
                  )}
                  {key == "max_time" && (
                    <DatePicker
                      showTimeSelect
                      dateFormat={DISPLAY_TIME}
                      onChange={(date) =>
                        clickYesNo(dateObjToDBTime(date), "max_time")
                      }
                      showTimeSelectOnly
                      name="default_end_time"
                      selected={mystate.farmDefaults.max_time}
                    />
                  )}

                  {key == "default_calendar_view" && (
                    <div style={{ width: 300 }}>
                      <Select
                        onChange={(selected) =>
                          clickYesNo(selected.value, "default_calendar_view")
                        }
                        options={viewOptions2}
                        defaultValue={viewOptions2.filter(
                          (option) =>
                            option.value ==
                              mystate.farmDefaults.default_calendar_view ||
                            null,
                        )}
                      />
                    </div>
                  )}
                  {key == "default_day_view" && (
                    <div style={{ width: 300 }}>
                      <Select
                        onChange={(selected) =>
                          clickYesNo(selected.value, "default_day_view")
                        }
                        options={dayOptions}
                        defaultValue={dayOptions.filter(
                          (option) =>
                            option.value ==
                              mystate.farmDefaults.default_day_view || null,
                        )}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
          <InputObject
            keyarray={[
              "timepicker_interval",
              "calendar_interval",
              "calendar_timeslot",
            ]}
          />
          <BoolObject
            keyarray={["monday_start", "show_lesson_by_client_name"]}
          />
        </div>
        <div style={sectionStyle}>
          <h3 style={sectionTitleStyle}>{"Receipt and Email Preferences"}</h3>
          <TextboxObject
            keyarray={[
              "invoice_notes1",
              "invoice_notes2",
              "invoice_email_notes1",
              "invoice_email_notes2",
              "receipt_email_notes1",
              "receipt_email_notes2",
            ]}
          />
        </div>

        <div style={sectionStyle}>
          <h3 style={sectionTitleStyle}>{"Stripe Account"}</h3>
          <div
            style={{
              fontSize: 16,
              width: 300,
              background: COLORS.blue,
              color: "white",
              padding: 5,
            }}
          >
            {"Stripe Account Connection"}
          </div>
          <div style={{ fontSize: 12 }}>
            {
              "Create or Connect your own Stripe account to be able to accept online credit and debit card payments in Equine Office "
            }
          </div>
          <div>
            {"Status: "}
            {mystate.farmDefaults.stripe_account_id
              ? "Connected"
              : "Not Connected"}
          </div>
          {!mystate.farmDefaults.stripe_account_id && (
            <a href="https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_GRa8ZKtBAxKvB2br6SSAZXr9JD7uqVyD&scope=read_write">
              Click to connect or create Stripe Account
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
